export default __webpack_public_path__ + "static/media/header-min.251dba89.jpg";